import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a04f751"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "使用帮助", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_6 = ["href"]

import { ref } from 'vue'
// import { QuestionCircleOutlined } from '@ant-design/icons-vue'

interface LiItem {
  title: string
  href: string
}

interface Props {
  list: LiItem[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'sider',
  props: {
    list: {}
  },
  setup(__props: any) {



const collapsed = ref(true)
const handleCollapse = () => {
  collapsed.value = !collapsed.value
}

return (_ctx: any,_cache: any) => {
  const _component_xn_icon = _resolveComponent("xn-icon")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!

  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_sider, {
        theme: "light",
        class: _normalizeClass(collapsed.value ? 'suspension sider' : 'sider'),
        width: collapsed.value ? '34px' : '208px'
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "m-header",
              onClick: handleCollapse,
              style: {"cursor":"pointer"}
            }, [
              _createVNode(_component_xn_icon, {
                icon: "homeRightShow",
                class: "xn-icon icon"
              })
            ])
          ], 512), [
            [_vShow, collapsed.value]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_xn_icon, {
                icon: "homeRightHide",
                class: "xn-icon icon",
                onClick: handleCollapse
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                (_ctx.list?.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (o) => {
                        return (_openBlock(), _createElementBlock("li", null, [
                          _hoisted_5,
                          _createElementVNode("a", {
                            href: o.href,
                            target: "_blank",
                            class: "xn-link"
                          }, _toDisplayString(o.title), 9, _hoisted_6)
                        ]))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 512), [
            [_vShow, !collapsed.value]
          ])
        ]),
        _: 3
      }, 8, ["class", "width"])
    ]),
    _: 3
  }))
}
}

})